<template>
  <b-card title="CPTs Aplicadas">
    <div v-if="loading">
      <b-skeleton animation="wave" width="85%"></b-skeleton>
      <b-skeleton animation="wave" width="55%"></b-skeleton>
      <b-skeleton animation="wave" width="70%"></b-skeleton>
    </div>
    <app-collapse accordion type="collapse-margin" v-else>
      <app-collapse-item :title="benef.beneficiario" v-for="benef in data" :key="benef.id_pessoa">
        <b-table
            ref="tblBeneficiaryCPT"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :items="benef.cpts"
            show-empty
            empty-text="Nenhum registro encontrado"
            class="position-relative tblBeneficiaryResume"
        />
      </app-collapse-item>
    </app-collapse>
  </b-card>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

import BeneficiaryService from "@/services/BeneficiaryService";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  name: "BeneficiariesCPT",
  components:{
    AppCollapse,
    AppCollapseItem
  },
  mounted() {
    this.loading = true;
    BeneficiaryService.getCPTSApplied().then(resp => {
      this.data = resp.data.map(item => {
        return {
          id: item.id,
          beneficiario: item.nome_completo,
          cpt: item.cpt,
          id_pessoa: item.id_pessoa
        }
      });

      const names = [];
      const uniques = [];

      for(let i = 0; i < this.data.length; i++) {
        if (!uniques.includes(this.data[i].id_pessoa)) {
          let cpts = this.data.filter(beneficiario => {
            return beneficiario.id_pessoa === this.data[i].id_pessoa
          })

          cpts = cpts.map(item => {
            return {
              id_cpt: item.id,
              cpt: item.cpt
            }
          })

          uniques.push(this.data[i].id_pessoa);

          names.push({id: this.data[i].id_pessoa, beneficiario: this.data[i].beneficiario, cpts: cpts})
        }
      }

      this.data = names;
      this.loading = false;
    }).catch(err => {
      this.loading = false;
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Oops!',
          icon: 'BellIcon',
          text: 'Ocorreu um erro ao buscar os dados de CPT dos beneficiarios.',
          variant: 'danger',
        },
      },
      {
        position: 'top-center'
      })
    })
  },
  data(){
    return {
      loading: false,
      data: [],
      tableColumns: [
        { key: 'id_cpt', sortable: false },
        { key: 'cpt', sortable: false },
      ]
    }
  }
}
</script>

<style scoped>

</style>